let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("68koG")).then(() => parcelRequire('htaza'));